import React from 'react';
import PropTypes from 'prop-types';
import PagePagination from 'components/PagePagination';
import { CSSTransition } from 'react-transition-group';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';

import './styles.css';

const List = props => {
  const {
    items,
    itemRender,
    actions,
    pagination,
    listStyles,
    pageRangeDisplayed = 5,
    scrollToTop = true,
  } = props;

  return (
    <CSSTransition
      in={!!items}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="list" style={listStyles}>
        {items.map((item, index) => itemRender(item, actions, index))}
        {pagination && pagination.count > pagination.perPage && (
          <div>
            <PagePagination
              scrollToTop={scrollToTop}
              page={pagination.page}
              perPage={pagination.perPage}
              count={pagination.count}
              pageRangeDisplayed={pageRangeDisplayed}
              controlFunc={actions.onChangePage}
              hideFirstLastPages={false}
              hideNavigation={true}
            />
          </div>
        )}
      </div>
    </CSSTransition>
  );
};

List.propTypes = {
  items: PropTypes.array.isRequired,
  itemRender: PropTypes.func.isRequired,
  scrollToTop: PropTypes.bool,
  actions: PropTypes.objectOf(PropTypes.func),
  pagination: PropTypes.shape({
    page: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    perPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  pageRangeDisplayed: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  listStyles: PropTypes.object,
};

export default List;
